import * as Yup from 'yup';
import { InferType } from 'yup';
export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const zipCodeRegex = /^[A-Za-z0-9]{5,6}$/;
const HospitalName = {
    label: "Hospital Name",
    validation: {
      valid: "Hospital Name is required",
      required: "Hospital Name is required"
    },
};

const Specialities = {
    label: "Specialities",
    validation: {
      valid: "Specialities is required",
      required: "Specialities is required"
    },
}

const contactNumber = {
    label: "Contact Number",
    validation: {
      valid: "Contact Number is required",
      required: "Contact Number is required"
    },
}

const email = {
    label: "Email",
    validation: {
      valid: "Email is not valid",
      required: "Email is required",
      invalidCaps: 'Email is invalid, please type in lowercase.',
    },
    regex: emailRegex
}

const Address = {
    label: "Address",
    validation: {
      valid: "Address is required",
      required: "Address is required"
    },
}

export const ZIP_CODE = {
  label: "Zip Code",
  validation: {
    required: "Zip Code is required",
    valid: "Zip Code must be a valid alphanumeric string with 5 or 6 characters",
    minLength: {
      value: 5,
      message: "Zip Code must be at least 5 digits",
    },
    maxLength: {
      value: 6,
      message: "Zip Code must not exceed 6 digits",
    },
  },
  regex: zipCodeRegex
};

const state = {
  label: "State",
  validation: {
    valid: "State is required",
    required: "State is required"
  }
}

const country = {
  label: "Country",
  validation: {
    valid: "Country is required",
    required: "Country is required"
  }
}

const city = {
  label: "City",
  validation: {
    valid: "City is required",
    required: "City is required"
  }
}


const FooterContactNumber = {
    label: "Footer Contact Number",
    validation: {
      valid: "Footer Contact Number is required",
      required: "Footer Contact Number is required"
    },
}

const FooterEmail = {
    label: "Footer Email",
    validation: {
      valid: "Footer Email is required",
      required: "Footer Email is required",
      invalidCaps: 'Email is invalid, please type in lowercase.',
    },
}

const FooterAddress = {
    label: "Footer Address",
    validation: {
      valid: "Footer Address is required",
      required: "Footer Address is required"
    },
}

export const reportsSettingsSchema = Yup.object().shape({
    hospitalName: Yup.string().required(HospitalName.validation.required),
    specialitites: Yup.array().required(Specialities.validation.required),
    contactNumber: Yup.string().required(contactNumber.validation.required),
    contactNumberCountryCode: Yup.string(),
    email: Yup.string().matches(email.regex, email.validation.valid).required(email.validation.required).test('no-uppercase', email.validation.invalidCaps, value => {
      return !value || value === value.toLowerCase();
    }),
    address: Yup.string().required(Address.validation.required),
    zipCode: Yup.string()
    .required(ZIP_CODE.validation.required)
    .min(ZIP_CODE.validation.minLength.value, ZIP_CODE.validation.minLength.message)
    .max(ZIP_CODE.validation.maxLength.value, ZIP_CODE.validation.maxLength.message)
    .matches(ZIP_CODE.regex, ZIP_CODE.validation.valid),
    country: Yup.string().required(country.validation.required),
    state: Yup.string().required(state.validation.required),
    city: Yup.string().required(city.validation.required),
    footerContactNumber: Yup.string().required(FooterContactNumber.validation.required),
    footerContactCountryCode: Yup.string(),
    footerEmail: Yup.string().email(FooterEmail.validation.valid).required(FooterEmail.validation.required).test('no-uppercase', FooterEmail.validation.invalidCaps, value => {
      return !value || value === value.toLowerCase();
    }),
    footerAddress: Yup.string().required(FooterAddress.validation.required),
})

export type ReportsSettingsSchema = InferType<typeof reportsSettingsSchema>;
